"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _Types = require("../util/Types");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ManageColumnView = function ManageColumnView(_ref) {
  var table = _ref.table,
    onColumnViewChange = _ref.onColumnViewChange,
    manageViewColumns = _ref.manageViewColumns;
  if (!manageViewColumns) {
    return null;
  }
  var _ref2 = (0, _react.useState)(null),
    _ref3 = _slicedToArray(_ref2, 2),
    anchorEl = _ref3[0],
    setAnchorEl = _ref3[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    return setAnchorEl(null);
  };
  var open = Boolean(anchorEl);
  var columns = table.columns;
  var viewColumns = columns.filter(function (col) {
    return col.role === _Types.cellTypes.DISPLAY;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: manageViewColumns.title
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    variant: "contained",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_icons.ViewColumn, null))), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    className: "viewColumnText"
  }, manageViewColumns.title), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleClose,
    className: "closeIcon"
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, null)), /*#__PURE__*/_react.default.createElement(_core.List, {
    className: "viewColumnList"
  }, viewColumns.map(function (column) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      width: 1,
      className: "viewColumnListItem"
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      icon: /*#__PURE__*/_react.default.createElement(_icons.CheckBoxOutlineBlank, {
        style: {
          fontSize: 18
        },
        className: "checkBoxIcon"
      }),
      onClick: function onClick() {
        return onColumnViewChange(column);
      },
      checked: column.display,
      checkedIcon: /*#__PURE__*/_react.default.createElement(_icons.CheckBox, {
        style: {
          fontSize: 18
        },
        className: "checkBoxIcon"
      }),
      disableRipple: true,
      color: "secondary",
      className: "checkBox"
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, null, column.header));
  }))));
};
var styles = function styles() {
  return {
    root: {
      padding: '16px 24px 16px 24px',
      fontFamily: 'Roboto'
    },
    title: {
      marginRight: '24px',
      fontSize: '14px',
      color: '#0B3556',
      textAlign: 'left',
      fontWeight: 500
    },
    formGroup: {
      marginTop: '8px'
    },
    formControl: {},
    checkbox: {
      padding: '0px',
      width: '32px',
      height: '32px'
    },
    checkboxRoot: {
      '&$checked': {
        color: '#0B3556'
      }
    },
    checked: {},
    label: {
      fontSize: '15px',
      marginLeft: '8px'
    }
  };
};
var _default = (0, _core.withStyles)(styles)(ManageColumnView);
exports.default = _default;